module.exports = __webpack_public_path__ + "static/media/image13.7a06739e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/OurTeam/image13.jpeg
// module id = 114
// module chunks = 0